import { configureStore } from '@reduxjs/toolkit';
import appReducer from './slices/appSlice';
import userReducer from './slices/userSlice';
import accessReducer from './slices/accessSlice';
import aiReducer from './slices/aiSlice';
import trendBuilderReducer from './slices/trendBuilderSlice';

const store = configureStore({
    reducer: {
        app: appReducer,
        user: userReducer,
        access: accessReducer,
        ai: aiReducer,
        trendBuilder: trendBuilderReducer,
    },
});

export default store;
